import { Link } from 'react-router-dom';

export default function PagoFallido() {
    return (
      <>
        <main className=" h-screen w-screen flex justify-center bg-white px-6 py-24 sm:py-32 lg:px-8">
          <div className="text-center">
            <p className="text-base font-semibold text-red-600">¡Ups! Ocurrió un error</p>
            <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">Tu pago no fue procesado</h1>
            <p className="mt-6 text-base leading-7 text-gray-600">No hemos generado ningún cobro. Revisa tu medio de pago y vuelve a intentarlo</p>
            <div className="mt-10 flex items-center justify-center gap-x-6">
              <Link
                to="/"
                className="rounded-md bg-red-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
              >
                Volver al inicio
              </Link>
            </div>
          </div>
        </main>
      </>
    )
}